/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_SavedInputs */

const en_cl_saved = /** @type {(inputs: Cl_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content language saved`)
};

const de_cl_saved = /** @type {(inputs: Cl_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltssprache gespeichert`)
};

/**
* | output |
* | --- |
* | "Content language saved" |
*
* @param {Cl_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_saved = /** @type {((inputs?: Cl_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_saved(inputs)
	return en_cl_saved(inputs)
});